import React from 'react';
import SetNewPasswordForm from './SetNewPasswordForm';
import { ToastProvider } from '../../providers/ToastProvider';

export default {
  title: 'Components/PasswordReset/SetNewPasswordForm',
  component: SetNewPasswordForm,
  tags: ['autodocs'],
  parameters: {
    layout: 'centered',
  },
  decorators: [
    (Story) => (
      <ToastProvider>
        <div className="p-8 bg-gray-50 min-h-100">
          <Story />
        </div>
      </ToastProvider>
    ),
  ],
};

export const Default = () => <SetNewPasswordForm />;
